export function getHoursAndMinutesFromSeconds(seconds: number) {
  const secondsToHours = Math.floor(seconds / 3600);
  const secondsToMinutes = Math.floor((seconds % 3600) / 60);

  return [secondsToHours, secondsToMinutes];
}
